export const optionsSkinTones = [
  "Branco/Caucasiano",
  "Pardo",
  "Negro/Afrodescendente",
  "Latino/Hispânico",
  "Asiático japonês",
  "Asiático chinês",
  "Asiático coreano",
  "Asiático outros",
  "Indiano",
  "Oriente Médio",
  "Outros",
];
